export default __webpack_public_path__ + "static/media/mintPrice.5ca72027.png";